"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sets = void 0;
class Sets {
    static diff(a, b) {
        return new Set([...a].filter(x => !b.has(x)));
    }
}
exports.Sets = Sets;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQWEsSUFBSTtJQUNmLE1BQU0sQ0FBQyxJQUFJLENBQUksQ0FBUyxFQUFFLENBQVM7UUFDakMsT0FBTyxJQUFJLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUMvQyxDQUFDO0NBQ0Y7QUFKRCxvQkFJQyJ9